<template>
  <div class="analise-relatorios-page">
    <section class="page-header">
      <div>
        <p class="kicker">Administracao</p>
        <h1>Validacao IA de Relatorios</h1>
      </div>
      <div class="header-actions">
        <v-btn outlined color="secondary" @click="$router.push({ name: 'analise-relatorios-ia.regras' })">
          <v-icon left small>mdi-tune</v-icon>
          Regras
        </v-btn>
        <v-btn color="primary" :loading="loadingExecucao" :disabled="loading" @click="analisarFiltrados">
          <v-icon left small>mdi-robot</v-icon>
          Analisar filtrados
        </v-btn>
        <v-btn
          outlined
          color="primary"
          :loading="loadingSincronizacao"
          :disabled="pendentesSincronizacao === 0"
          @click="sincronizarDecisoes"
        >
          <v-icon left small>mdi-database-check</v-icon>
          Aplicar decisoes
        </v-btn>
        <v-btn outlined color="secondary" :disabled="!resultados.length" @click="exportarXls">
          <v-icon left small>mdi-file-excel-outline</v-icon>
          XLS
        </v-btn>
        <v-btn outlined color="secondary" :disabled="!resultados.length" @click="exportarPdf">
          <v-icon left small>mdi-file-pdf-box</v-icon>
          PDF
        </v-btn>
        <v-btn outlined color="secondary" :loading="loading" :disabled="!buscaAplicada" @click="carregarPainel">
          <v-icon left small>mdi-refresh</v-icon>
          Atualizar
        </v-btn>
      </div>
    </section>

    <v-row dense>
      <v-col cols="6" md="3" lg="2" v-for="card in cards" :key="card.label">
        <v-card outlined class="metric-card">
          <v-card-text>
            <div class="metric-label">{{ card.label }}</div>
            <div class="metric-value">{{ card.value }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card outlined class="filter-panel">
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" lg="1">
            <v-select v-model="filtro.uf" :items="ufs" label="UF" outlined dense hide-details />
          </v-col>
          <v-col cols="12" sm="6" lg="2">
            <v-select
              v-model="filtro.unidadeRegionalId"
              :items="opcoes.unidadesRegionais"
              item-text="nome"
              item-value="id"
              label="Unidade regional"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" lg="2">
            <v-select
              v-model="filtro.municipioId"
              :items="opcoes.municipios"
              item-text="nome"
              item-value="id"
              label="Municipio"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" lg="2">
            <v-select
              v-model="filtro.grupoSolucaoId"
              :items="opcoes.gruposSolucoes"
              item-text="nome"
              item-value="id"
              label="Grupo de solucao"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" lg="2">
            <v-select
              v-model="filtro.solucaoId"
              :items="opcoes.solucoes"
              item-text="nome"
              item-value="id"
              label="Solucao"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <v-select
              v-model="filtro.responsavelId"
              :items="opcoes.responsaveis"
              item-text="nome"
              item-value="id"
              label="Consultor/responsavel"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
        </v-row>
        <v-row dense class="mt-2">
          <v-col cols="12" sm="6" lg="2">
            <v-text-field v-model="filtro.dataInicial" type="date" label="Periodo inicial" outlined dense clearable hide-details />
          </v-col>
          <v-col cols="12" sm="6" lg="2">
            <v-text-field v-model="filtro.dataFinal" type="date" label="Periodo final" outlined dense clearable hide-details />
          </v-col>
          <v-col cols="12" sm="6" lg="2">
            <v-select
              v-model="filtro.statusRelatorioId"
              :items="statusRelatorioOptions"
              item-text="text"
              item-value="value"
              label="Status relatorio"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <v-select
              v-model="filtro.statusAnaliseIa"
              :items="statusAnaliseOptions"
              item-text="text"
              item-value="value"
              label="Status analise IA"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" lg="2">
            <v-select
              v-model="filtro.statusDecisaoAplicada"
              :items="statusAplicacaoOptions"
              item-text="text"
              item-value="value"
              label="Decisao aplicada"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" lg="1" class="filter-actions">
            <v-btn color="primary" block :loading="loading" @click="aplicarFiltros">Filtrar</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card outlined class="rules-panel">
      <v-card-title class="rules-title">
        <span>Regras da UF</span>
        <v-spacer />
        <v-btn outlined color="primary" :loading="loadingRegras" @click="atualizarRegrasHistorico">
          <v-icon left small>mdi-brain</v-icon>
          Atualizar pelo historico
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headersRegras"
          :items="regras"
          dense
          disable-pagination
          hide-default-footer
          no-data-text="Nenhuma regra historica ativa para esta UF."
        >
          <template v-slot:item.textoRegra="{ item }">
            <div class="line-clamp rule-text">{{ item.textoRegra }}</div>
          </template>
          <template v-slot:item.historico="{ item }">
            <div>{{ item.totalOcorrencias }} ocorr.; {{ item.totalAprovacoesHumanas }} aprov.; {{ item.totalRejeicoesHumanas }} rej.</div>
            <small class="muted">peso {{ formatNumber(item.pesoHistorico) }}; ult. {{ formatDate(item.ultimaOcorrencia) }}</small>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card outlined class="results-panel">
      <v-data-table
        :headers="headers"
        :items="resultados"
        :loading="loading"
        class="elevation-0 results-table"
        :items-per-page="10"
        no-data-text="Nenhum relatorio encontrado para os filtros aplicados."
      >
        <template v-slot:item.dataExecucao="{ item }">{{ formatDate(item.dataExecucao) }}</template>
        <template v-slot:item.solucao="{ item }">
          <div class="stacked">
            <strong>{{ item.grupoSolucao || "-" }}</strong>
            <span>{{ item.solucao || "-" }}</span>
          </div>
        </template>
        <template v-slot:item.statusRelatorio="{ item }">
          <v-chip small :color="statusRelatorioColor(item.statusRelatorioId)" dark>{{ item.statusRelatorio }}</v-chip>
        </template>
        <template v-slot:item.statusAnaliseIa="{ item }">
          <v-chip small :color="decisionColor(item.decisaoIa)" dark>{{ item.statusAnaliseIa }}</v-chip>
        </template>
        <template v-slot:item.confiancaIa="{ item }">{{ formatPercent(item.confiancaIa) }}</template>
        <template v-slot:item.anexos="{ item }">
          <div v-if="item.anexosDetalhes && item.anexosDetalhes.length" class="attachment-list">
            <button
              v-for="anexo in item.anexosDetalhes"
              :key="anexo.relatorioAnexoId"
              type="button"
              class="attachment-link"
              @click="baixarAnexo(anexo)"
            >
              {{ anexo.nome }}
            </button>
          </div>
          <span v-else>Sem anexos</span>
        </template>
        <template v-slot:item.sugestaoJustificativaRejeicao="{ item }">
          <div class="line-clamp">{{ item.sugestaoJustificativaRejeicao || "-" }}</div>
        </template>
        <template v-slot:item.sincronizado="{ item }">
          <v-chip v-if="item.sincronizado" small color="green" dark>Aplicada</v-chip>
          <v-chip v-else-if="deveSincronizar(item.decisaoHumana)" small color="orange" dark>A aplicar</v-chip>
          <span v-else>-</span>
        </template>
        <template v-slot:item.acoes="{ item }">
          <v-btn icon small title="Abrir relatorio" @click="abrirDetalhe(item)">
            <v-icon small color="primary">mdi-information-outline</v-icon>
          </v-btn>
          <v-btn icon small title="Decisao humana" :disabled="!item.temAnaliseIa" @click="abrirDecisao(item)">
            <v-icon small color="secondary">mdi-check-decagram</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogDetalhe" max-width="960">
      <v-card v-if="itemSelecionado">
        <v-card-title>Relatorio completo</v-card-title>
        <v-card-text>
          <div class="detail-grid">
            <p><strong>Unidade regional:</strong> {{ itemSelecionado.unidadeRegional || "-" }}</p>
            <p><strong>Municipio:</strong> {{ itemSelecionado.municipio }}</p>
            <p><strong>Consultor:</strong> {{ itemSelecionado.consultor || "-" }}</p>
            <p><strong>Data:</strong> {{ formatDate(itemSelecionado.dataExecucao) }}</p>
            <p><strong>Grupo:</strong> {{ itemSelecionado.grupoSolucao || "-" }}</p>
            <p><strong>Solucao:</strong> {{ itemSelecionado.solucao || "-" }}</p>
            <p><strong>Status relatorio:</strong> {{ itemSelecionado.statusRelatorio || "-" }}</p>
            <p><strong>Status IA:</strong> {{ itemSelecionado.statusAnaliseIa || "-" }}</p>
          </div>

          <p><strong>Tarefas:</strong> {{ itemSelecionado.tarefas || "-" }}</p>
          <div class="mb-3">
            <strong>Anexos:</strong>
            <div v-if="itemSelecionado.anexosDetalhes && itemSelecionado.anexosDetalhes.length" class="attachment-list mt-1">
              <button
                v-for="anexo in itemSelecionado.anexosDetalhes"
                :key="anexo.relatorioAnexoId"
                type="button"
                class="attachment-link"
                @click="baixarAnexo(anexo)"
              >
                {{ anexo.nome }}
              </button>
            </div>
            <span v-else> Sem anexos</span>
          </div>

          <v-alert type="warning" outlined dense v-if="itemSelecionado.inconsistencias && itemSelecionado.inconsistencias.length">
            <div v-for="inc in itemSelecionado.inconsistencias" :key="inc">{{ inc }}</div>
          </v-alert>
          <v-alert type="info" outlined dense v-if="itemSelecionado.sugestoes && itemSelecionado.sugestoes.length">
            <div v-for="sug in itemSelecionado.sugestoes" :key="sug">{{ sug }}</div>
          </v-alert>
          <v-textarea
            :value="itemSelecionado.sugestaoJustificativaRejeicao"
            label="Sugestao de mensagem ao consultor em caso de rejeicao"
            outlined
            readonly
            rows="5"
          />
          <pre class="report-text">{{ itemSelecionado.textoRelatorio }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDetalhe = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDecisao" max-width="760">
      <v-card>
        <v-card-title>Decisao humana</v-card-title>
        <v-card-text>
          <v-alert outlined dense type="info">
            Aprovar ou rejeitar aplica a decisao no relatorio imediatamente. A rejeicao grava o motivo e envia o e-mail existente ao consultor.
          </v-alert>
          <v-select
            v-model="decisaoForm.decisaoHumana"
            :items="decisoesHumanas"
            item-text="text"
            item-value="value"
            label="Decisao operacional"
            outlined
            dense
          />
          <v-textarea
            v-model="decisaoForm.justificativaHumana"
            :label="justificativaLabel"
            :hint="justificativaHint"
            persistent-hint
            outlined
            rows="7"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDecisao = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="saving" @click="salvarDecisao">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { saveAs } from "file-saver";
import { analiseRelatoriosIaApi } from "../services/api";
import { atualUfDefinition } from "../../../helpers/utils";

export default {
  name: "AnaliseRelatoriosIaPainel",
  data() {
    return {
      loading: false,
      loadingExecucao: false,
      loadingSincronizacao: false,
      loadingRegras: false,
      saving: false,
      buscaAplicada: false,
      painel: { resumo: {}, execucoes: [], resultados: [] },
      opcoes: {
        unidadesRegionais: [],
        municipios: [],
        gruposSolucoes: [],
        solucoes: [],
        responsaveis: [],
      },
      filtro: {
        uf: "SC",
        unidadeRegionalId: null,
        municipioId: null,
        grupoSolucaoId: null,
        solucaoId: null,
        responsavelId: null,
        dataInicial: null,
        dataFinal: null,
        statusRelatorioId: null,
        statusAnaliseIa: null,
        statusDecisaoAplicada: null,
        relatorioId: null,
      },
      ufs: ["SC", "MS", "RJ", "MA", "BA", "SP"],
      statusRelatorioOptions: [
        { text: "Nao analisado", value: 1 },
        { text: "Aprovado", value: 2 },
        { text: "Reprovado", value: 3 },
        { text: "Em pagamento", value: 4 },
      ],
      statusAnaliseOptions: [
        { text: "Sem analise IA", value: "SEM_ANALISE" },
        { text: "Aprovacao sugerida", value: "APROVACAO_SUGERIDA" },
        { text: "Rejeicao sugerida", value: "REJEICAO_SUGERIDA" },
        { text: "Analise humana necessaria", value: "HUMANA_NECESSARIA" },
      ],
      statusAplicacaoOptions: [
        { text: "Com decisao aplicada", value: "COM" },
        { text: "Sem decisao aplicada", value: "SEM" },
      ],
      decisoesHumanas: [
        { text: "Aprovar relatorio", value: "APROVAR" },
        { text: "Manter para revisao", value: "REVISAR" },
        { text: "Rejeitar relatorio", value: "REJEITAR" },
      ],
      dialogDetalhe: false,
      dialogDecisao: false,
      itemSelecionado: null,
      decisaoForm: { decisaoHumana: "APROVAR", justificativaHumana: "" },
      headers: [
        { text: "Regional", value: "unidadeRegional", width: 130 },
        { text: "Municipio", value: "municipio", width: 140 },
        { text: "Grupo/Solucao", value: "solucao", width: 220 },
        { text: "Consultor", value: "consultor", width: 170 },
        { text: "Data", value: "dataExecucao", width: 120 },
        { text: "Relatorio", value: "statusRelatorio", width: 130 },
        { text: "IA", value: "statusAnaliseIa", width: 170 },
        { text: "Conf.", value: "confiancaIa", width: 80 },
        { text: "Anexos", value: "anexos", sortable: false, width: 170 },
        { text: "Sugestao de rejeicao", value: "sugestaoJustificativaRejeicao", width: 280 },
        { text: "Aplicacao", value: "sincronizado", width: 120 },
        { text: "", value: "acoes", sortable: false, align: "end", width: 90 },
      ],
      headersRegras: [
        { text: "Tipo", value: "tipo", width: 160 },
        { text: "Regra", value: "textoRegra" },
        { text: "Historico", value: "historico", width: 260 },
      ],
    };
  },
  computed: {
    resultados() {
      return this.painel.resultados || [];
    },
    regras() {
      return this.painel.regras || [];
    },
    cards() {
      const resumo = this.painel.resumo || {};
      return [
        { label: "Relatorios", value: resumo.totalRelatorios || 0 },
        { label: "Sem analise", value: this.resultados.filter((x) => !x.temAnaliseIa).length },
        { label: "Aprovacao IA", value: resumo.adequadosIa || 0 },
        { label: "Rejeicao IA", value: resumo.revisaoIa || 0 },
        { label: "Humana", value: resumo.revisaoHumanaPosterior || 0 },
        { label: "Aplicados", value: resumo.sincronizadosRelatorio || 0 },
        { label: "A aplicar", value: resumo.pendentesSincronizacao || 0 },
      ];
    },
    pendentesSincronizacao() {
      return (this.painel.resumo || {}).pendentesSincronizacao || 0;
    },
    justificativaLabel() {
      if (this.decisaoForm.decisaoHumana === "REJEITAR") {
        return "Mensagem ao consultor em caso de rejeicao";
      }
      if (this.decisaoForm.decisaoHumana === "APROVAR") {
        return "Observacao interna da aprovacao";
      }
      return "Orientacao interna para revisao";
    },
    justificativaHint() {
      if (this.decisaoForm.decisaoHumana === "REJEITAR") {
        return "Este texto sera gravado como motivo de rejeicao e usado no e-mail enviado ao gerador do relatorio.";
      }
      if (this.decisaoForm.decisaoHumana === "APROVAR") {
        return "Aprovacao atualiza o relatorio como aprovado. O texto permanece no historico da analise IA.";
      }
      return "Revisar registra a decisao no painel sem alterar o status do relatorio.";
    },
  },
  watch: {
    "filtro.uf": async function () {
      this.filtro.unidadeRegionalId = null;
      this.filtro.municipioId = null;
      this.filtro.grupoSolucaoId = null;
      this.filtro.solucaoId = null;
      this.filtro.responsavelId = null;
      this.filtro.relatorioId = null;
      this.buscaAplicada = false;
      this.painel = { resumo: {}, execucoes: [], resultados: [], regras: [] };
      await this.carregarOpcoes();
      await this.carregarRegras();
    },
  },
  async mounted() {
    const params = new URLSearchParams(window.location.search || "");
    const relatorioId = params.get("relatorioId");
    if (relatorioId) {
      this.filtro.relatorioId = Number(relatorioId);
      this.buscaAplicada = true;
    }
    await this.carregarOpcoes();
    if (this.buscaAplicada) {
      await this.carregarPainel();
    } else {
      await this.carregarRegras();
    }
  },
  methods: {
    async carregarOpcoes() {
      this.opcoes = await analiseRelatoriosIaApi.obterOpcoes({ uf: this.filtro.uf });
    },
    async carregarRegras() {
      const painel = await analiseRelatoriosIaApi.obterPainel({ uf: this.filtro.uf });
      this.painel = { resumo: {}, execucoes: [], resultados: [], regras: painel.regras || [] };
    },
    temFiltroAplicado() {
      return Boolean(
        this.filtro.unidadeRegionalId ||
          this.filtro.municipioId ||
          this.filtro.grupoSolucaoId ||
          this.filtro.solucaoId ||
          this.filtro.responsavelId ||
          this.filtro.relatorioId ||
          this.filtro.statusRelatorioId ||
          this.filtro.dataInicial ||
          this.filtro.dataFinal ||
          this.filtro.statusAnaliseIa ||
          this.filtro.statusDecisaoAplicada
      );
    },
    async carregarPainel() {
      if (!this.temFiltroAplicado()) {
        this.buscaAplicada = false;
        this.painel = { resumo: {}, execucoes: [], resultados: [], regras: this.regras };
        return;
      }
      this.loading = true;
      try {
        this.painel = await analiseRelatoriosIaApi.obterPainel(this.filtro);
        if (this.filtro.relatorioId && this.resultados.length === 1) {
          this.abrirDetalhe(this.resultados[0]);
        }
      } finally {
        this.loading = false;
      }
    },
    async aplicarFiltros() {
      if (!this.temFiltroAplicado()) {
        this.$notification.error("Informe ao menos um filtro antes de carregar relatorios.");
        return;
      }
      this.filtro.relatorioId = null;
      this.buscaAplicada = true;
      await this.carregarPainel();
    },
    async analisarFiltrados() {
      if (!this.temFiltroAplicado()) {
        this.$notification.error("Informe os filtros antes de analisar relatorios.");
        return;
      }
      this.loadingExecucao = true;
      try {
        const execucao = await analiseRelatoriosIaApi.criarExecucao(this.filtro);
        await this.carregarPainel();
        const total = execucao && execucao.totalRelatorios !== undefined ? execucao.totalRelatorios : 0;
        this.$notification.success(`${total} relatorio(s) analisado(s) pela IA.`);
      } finally {
        this.loadingExecucao = false;
      }
    },
    async atualizarRegrasHistorico() {
      this.loadingRegras = true;
      try {
        const resultado = await analiseRelatoriosIaApi.atualizarRegrasHistorico({ uf: this.filtro.uf });
        this.painel = { ...this.painel, regras: resultado.regras || [] };
        this.$notification.success(`${resultado.totalRegrasGeradas} regra(s) atualizada(s) a partir do historico.`);
      } finally {
        this.loadingRegras = false;
      }
    },
    abrirDetalhe(item) {
      this.itemSelecionado = item;
      this.dialogDetalhe = true;
    },
    abrirDecisao(item) {
      this.itemSelecionado = item;
      this.decisaoForm = {
        decisaoHumana: item.decisaoIa === "ADEQUADO" ? "APROVAR" : "REVISAR",
        justificativaHumana: item.justificativaHumana || item.sugestaoJustificativaRejeicao || "",
      };
      this.dialogDecisao = true;
    },
    async salvarDecisao() {
      if (!this.itemSelecionado || !this.itemSelecionado.analiseRelatoriosIaItemId) return;
      if (this.decisaoForm.decisaoHumana === "REJEITAR" && !String(this.decisaoForm.justificativaHumana || "").trim()) {
        this.$notification.error("Informe a mensagem que sera enviada ao consultor.");
        return;
      }
      this.saving = true;
      try {
        await analiseRelatoriosIaApi.registrarDecisao(this.itemSelecionado.analiseRelatoriosIaItemId, this.decisaoForm);
        this.dialogDecisao = false;
        await this.carregarPainel();
        this.$notification.success(this.deveSincronizar(this.decisaoForm.decisaoHumana) ? "Decisao aplicada no relatorio." : "Decisao registrada para revisao.");
      } finally {
        this.saving = false;
      }
    },
    async sincronizarDecisoes() {
      this.loadingSincronizacao = true;
      try {
        const resultado = await analiseRelatoriosIaApi.sincronizarDecisoes(this.filtro);
        await this.carregarPainel();
        const erros = resultado.erros && resultado.erros.length ? ` Erros: ${resultado.erros.join("; ")}` : "";
        this.$notification.success(`${resultado.totalSincronizados} decisao(oes) aplicada(s) em relatorios.${erros}`);
      } finally {
        this.loadingSincronizacao = false;
      }
    },
    async baixarAnexo(anexo) {
      const blob = await analiseRelatoriosIaApi.baixarAnexo(anexo.relatorioAnexoId);
      saveAs(blob, anexo.nome || `anexo-${anexo.relatorioAnexoId}`);
    },
    exportarXls() {
      const columns = this.exportColumns();
      const rows = this.exportRows();
      const aoa = [columns.map((col) => col.label)].concat(rows.map((row) => columns.map((col) => row.values[col.key] || "")));
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      rows.forEach((row, rowIndex) => {
        columns.forEach((col, colIndex) => {
          const link = row.links[col.key];
          if (!link) return;
          const address = XLSX.utils.encode_cell({ r: rowIndex + 1, c: colIndex });
          if (!ws[address]) return;
          ws[address].l = { Target: link, Tooltip: row.values[col.key] || "Abrir" };
          ws[address].s = { font: { color: { rgb: "0563C1" }, underline: true } };
        });
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Relatorios IA");
      XLSX.writeFile(wb, this.nomeArquivo("relatorios-ia", "xlsx"));
    },
    exportarPdf() {
      const columns = this.exportColumns().filter((col) =>
        ["Relatorio", "Regional", "Municipio", "Consultor", "Data", "StatusRelatorio", "StatusAnaliseIa", "DecisaoHumana", "DecisaoAplicada", "Anexo1", "Anexo2", "Anexo3", "SugestaoJustificativaRejeicao"].includes(col.key)
      );
      const rows = this.exportRows();
      const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
      doc.setFontSize(12);
      doc.text("Validacao IA de Relatorios", 40, 32);
      autoTable(doc, {
        startY: 48,
        head: [columns.map((col) => col.label)],
        body: rows.map((row) => columns.map((col) => row.values[col.key] || "")),
        styles: { fontSize: 7, cellPadding: 3, overflow: "linebreak" },
        headStyles: { fillColor: [23, 93, 142] },
        columnStyles: {
          12: { cellWidth: 170 },
        },
        didDrawCell: (data) => {
          if (data.section !== "body") return;
          const row = rows[data.row.index];
          const col = columns[data.column.index];
          const link = row && col ? row.links[col.key] : null;
          if (!link) return;
          doc.link(data.cell.x, data.cell.y, data.cell.width, data.cell.height, { url: link });
        },
      });
      doc.save(this.nomeArquivo("relatorios-ia", "pdf"));
    },
    exportColumns() {
      const maxAnexos = Math.max(1, ...this.resultados.map((item) => (item.anexosDetalhes || []).length));
      const anexos = Array.from({ length: Math.min(maxAnexos, 8) }).map((_, index) => ({
        key: `Anexo${index + 1}`,
        label: `Anexo ${index + 1}`,
      }));
      return [
        { key: "Relatorio", label: "Relatorio" },
        { key: "RelatorioId", label: "RelatorioId" },
        { key: "Regional", label: "Regional" },
        { key: "Municipio", label: "Municipio" },
        { key: "GrupoSolucao", label: "GrupoSolucao" },
        { key: "Solucao", label: "Solucao" },
        { key: "Consultor", label: "Consultor" },
        { key: "Data", label: "Data" },
        { key: "Horas", label: "Horas" },
        { key: "StatusRelatorio", label: "StatusRelatorio" },
        { key: "StatusAnaliseIa", label: "StatusAnaliseIa" },
        { key: "DecisaoIa", label: "DecisaoIa" },
        { key: "ConfiancaIa", label: "ConfiancaIa" },
        { key: "RiscoIa", label: "RiscoIa" },
        { key: "JustificativaIa", label: "JustificativaIa" },
        { key: "Inconsistencias", label: "Inconsistencias" },
        { key: "Sugestoes", label: "Sugestoes" },
        { key: "SugestaoJustificativaRejeicao", label: "SugestaoJustificativaRejeicao" },
        { key: "DecisaoHumana", label: "DecisaoHumana" },
        { key: "JustificativaHumana", label: "JustificativaHumana" },
        { key: "DecisaoAplicada", label: "DecisaoAplicada" },
        ...anexos,
      ];
    },
    exportRows() {
      return this.resultados.map((item) => ({
        values: this.exportValues(item),
        links: this.exportLinks(item),
      }));
    },
    exportValues(item) {
      const values = {
        Relatorio: "Abrir relatorio",
        RelatorioId: item.relatorioId,
        Regional: item.unidadeRegional || "",
        Municipio: item.municipio || "",
        GrupoSolucao: item.grupoSolucao || "",
        Solucao: item.solucao || "",
        Consultor: item.consultor || "",
        Data: this.formatDate(item.dataExecucao),
        Horas: item.horasUtilizadas || "",
        StatusRelatorio: item.statusRelatorio || "",
        StatusAnaliseIa: item.statusAnaliseIa || "",
        DecisaoIa: item.decisaoIa || "",
        ConfiancaIa: this.formatPercent(item.confiancaIa),
        RiscoIa: item.nivelRiscoIa || "",
        JustificativaIa: item.justificativaIa || "",
        Inconsistencias: (item.inconsistencias || []).join(" | "),
        Sugestoes: (item.sugestoes || []).join(" | "),
        SugestaoJustificativaRejeicao: item.sugestaoJustificativaRejeicao || "",
        DecisaoHumana: item.decisaoHumana || "",
        JustificativaHumana: item.justificativaHumana || "",
        DecisaoAplicada: item.sincronizado ? "Com decisao aplicada" : "Sem decisao aplicada",
      };
      (item.anexosDetalhes || []).slice(0, 8).forEach((anexo, index) => {
        values[`Anexo${index + 1}`] = anexo.nome || `Anexo ${index + 1}`;
      });
      return values;
    },
    exportLinks(item) {
      const links = { Relatorio: this.relatorioUrl(item) };
      (item.anexosDetalhes || []).slice(0, 8).forEach((anexo, index) => {
        links[`Anexo${index + 1}`] = this.absoluteDownloadUrl(anexo);
      });
      return links;
    },
    relatorioUrl(item) {
      const params = new URLSearchParams(window.location.search || "");
      params.set("banco", params.get("banco") || "ce-sc-hlg");
      params.set("branch", params.get("branch") || "hlg");
      params.set("relatorioId", item.relatorioId);
      return `${window.location.origin}${window.location.pathname}?${params.toString()}#/analise-relatorios-ia/validacao`;
    },
    absoluteDownloadUrl(anexo) {
      const base = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
        ? process.env.VUE_APP_BASE_API_LOCAL || "http://localhost:64332/"
        : (atualUfDefinition && atualUfDefinition.env) || window.location.origin;
      const cleanBase = base.endsWith("/") ? base.slice(0, -1) : base;
      const path = anexo.urlDownload || `/api/arquivo/anexo/download/${anexo.relatorioAnexoId}`;
      const params = new URLSearchParams(window.location.search || "");
      const banco = params.get("banco") || "ce-sc-hlg";
      const branch = params.get("branch") || "hlg";
      const join = path.indexOf("?") >= 0 ? "&" : "?";
      return `${cleanBase}${path}${join}banco=${encodeURIComponent(banco)}&branch=${encodeURIComponent(branch)}`;
    },
    nomeArquivo(prefixo, extensao) {
      const stamp = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, "");
      return `${prefixo}-${stamp}.${extensao}`;
    },
    deveSincronizar(decisao) {
      return decisao === "APROVAR" || decisao === "REJEITAR";
    },
    formatDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString("pt-BR");
    },
    formatPercent(value) {
      if (value === null || value === undefined || value === "") return "-";
      return `${Math.round(Number(value) * 100)}%`;
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === "") return "0";
      return Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 2 });
    },
    decisionColor(decision) {
      if (decision === "ADEQUADO") return "green";
      if (decision === "REVISAO_HUMANA") return "red";
      if (decision === "RECOMENDAR_REVISAO") return "orange";
      return "grey";
    },
    statusRelatorioColor(status) {
      if (status === 2) return "green";
      if (status === 3) return "red";
      if (status === 4) return "blue-grey";
      return "grey";
    },
  },
};
</script>

<style scoped>
.analise-relatorios-page {
  padding-bottom: 24px;
}
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.kicker {
  margin: 0 0 4px;
  font-size: 12px;
  text-transform: uppercase;
  color: #546e7a;
}
.page-header h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
}
.header-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.metric-card,
.filter-panel,
.rules-panel,
.results-panel {
  border-radius: 6px;
}
.metric-card {
  min-height: 86px;
}
.metric-label {
  color: #607d8b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}
.metric-value {
  margin-top: 8px;
  color: #263238;
  font-size: 24px;
  line-height: 1;
}
.filter-panel {
  margin: 16px 0;
}
.rules-panel {
  margin-bottom: 16px;
}
.rules-title {
  font-size: 16px;
  font-weight: 600;
}
.rule-text {
  max-width: 760px;
}
.muted {
  color: #607d8b;
}
.filter-actions {
  display: flex;
  align-items: center;
}
.results-table {
  width: 100%;
}
.stacked {
  display: grid;
  gap: 2px;
  min-width: 180px;
}
.stacked span {
  color: #546e7a;
  font-size: 12px;
}
.line-clamp {
  max-width: 280px;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.attachment-list {
  display: grid;
  gap: 4px;
}
.attachment-link {
  padding: 0;
  border: 0;
  background: transparent;
  color: #1565c0;
  cursor: pointer;
  font: inherit;
  text-align: left;
  text-decoration: underline;
}
.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 16px;
}
.report-text {
  padding: 12px;
  border: 1px solid #d9e1e7;
  border-radius: 6px;
  background: #fafafa;
  white-space: pre-wrap;
  font: inherit;
  line-height: 1.45;
}
@media (max-width: 960px) {
  .page-header {
    display: block;
  }
  .header-actions {
    justify-content: flex-start;
    margin-top: 12px;
  }
  .detail-grid {
    grid-template-columns: 1fr;
  }
}
</style>
